<div class="container p-0 col-lg-6 mt-3">
  <h5 class="mb-5 px-3 py-2 border-top border-2 border-accent bg-stripe">
    {{ 'rrs.pageNotFound.title' | cxTranslate }}
  </h5>
  <div class="mx-2 mx-lg-5">
    <cx-page-slot position="not_found_main_slot"></cx-page-slot>
  </div>
</div>
